import { render, staticRenderFns } from "./laboratorioForm.vue?vue&type=template&id=663fc086&scoped=true&"
import script from "./laboratorioForm.vue?vue&type=script&lang=js&"
export * from "./laboratorioForm.vue?vue&type=script&lang=js&"
import style0 from "./laboratorioForm.vue?vue&type=style&index=0&id=663fc086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663fc086",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VForm,VLayout,VTextField})
